import Box from "@mui/material/Box";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import { useAuth } from "../../features/auth/hooks/use-auth";
import { useCore } from "../../shared/hooks/use-core";
import { ToastContainer } from "react-toastify";
// import useWebSocket from 'react-use-websocket'
import NavBar from "../../shared/components/nav-bar";
import { appTheme } from "../../shared/styles/theme";
import CssBaseline from "@mui/material/CssBaseline";
import SideBar, { drawerWidth } from "../../shared/components/side-bar";
import useWindowSize from "../../shared/hooks/use-window-size";
import { WebMenu } from "./menu";
import { memo } from "react";
import { Grid, ThemeProvider, Paper } from "@mui/material";

interface Props {
	window?: () => Window;
}

function ResponsiveDrawer(props: Props) {
	const { user } = useAuth();
	const location = useLocation();
	const { displayAlt, sidebarCollapsed } = useCore();
	const { width } = useWindowSize();

	const isBlockedForWebProfile =
		user?.profile === "4" &&
		!WebMenu.includes(location.pathname) &&
		!location.pathname.startsWith("/query/");

	// const { lastJsonMessage } = useWebSocket(
	//   'wss://ntfy.sh/teste/ws', {
	//     onOpen: () => toast.success('Connected', {
	//       position: toast.POSITION.TOP_RIGHT
	//     }),
	//     onMessage: () => {
	//       if (lastJsonMessage) {
	//         const message = lastJsonMessage as {[key: string]: any}
	//         toast.info(message['message'], {
	//           position: toast.POSITION.TOP_RIGHT
	//         })
	//       }
	//     },
	//     onError: (event) => {
	//       toast.error(event.toString(), {
	//         position: toast.POSITION.TOP_RIGHT
	//       })
	//     },
	//     shouldReconnect: (closeEvent) => true,
	//     reconnectInterval: 5000
	//   }
	// )

	return (
		<ThemeProvider theme={appTheme}>
			<ToastContainer />
			<Box sx={{ display: width >= 600 ? "flex" : displayAlt }}>
				<CssBaseline />
				<NavBar />
				<SideBar />
				{/* Content */}
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						p: 3,
						width: {
							sm: sidebarCollapsed ? "100%" : `calc(100% - ${drawerWidth}px)`,
						},
					}}
				>
					<Toolbar />
					<Grid
						container
						spacing={0}
						direction="column"
						alignItems="center"
						justifyContent="center"
					>
						<Paper
							sx={{
								width: "100%",
								marginBottom: "20px",
								padding: "20px",
							}}
							variant="outlined"
						>
							{isBlockedForWebProfile ? (
								<Navigate to="/" replace />
							) : (
								<Outlet />
							)}
						</Paper>
					</Grid>
				</Box>
			</Box>
		</ThemeProvider>
	);
}

ResponsiveDrawer.defaultProps = {
	displayAlt: "flex",
};

export default memo(ResponsiveDrawer);
